'use client'

import { captureException } from '@sentry/nextjs'
import type { ReactNode } from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import type { FallbackProps } from 'react-error-boundary'
import { clearIDB } from '@packages/utilities/utils'

const DefaultFallback: React.FC<FallbackProps> = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center gap-2">
      <h2>Something went wrong!</h2>
      <p>Please refresh the page and try again</p>
    </div>
  )
}

interface Properties {
  children: ReactNode
  customFallback?: ReactNode
  onError?: (error: Error) => void | Promise<void>
}

const ErrorBoundary: React.FC<Properties> = ({
  children,
  customFallback,
  onError,
}) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={
        customFallback ? () => <>{customFallback}</> : DefaultFallback
      }
      onError={(error) => {
        captureException(error)
        clearIDB().catch((error: unknown) => {
          captureException(error)
        })
        void onError?.(error)
      }}
    >
      {children}
    </ReactErrorBoundary>
  )
}

export default ErrorBoundary
